import React from 'react';

const SvgFiles17 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 16" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M11 9.5a.5.5 0 0 1-.5.5H8v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V10H3.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H6V5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V8h2.5a.5.5 0 0 1 .5.5zM18 2h-5.59a1 1 0 0 1-.7-.29L10.29.29a1 1 0 0 0-.7-.29H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgFiles17 svgRef={ref} {...props} />);
export default ForwardRef;
